"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M3.5 4a.5.5 0 0 0 0 1h1.248a1 1 0 0 1 .984.821l1.552 8.537A2 2 0 0 0 9.252 16H16.5a.5.5 0 0 0 0-1H9.252a1 1 0 0 1-.984-.821L8.054 13h8.165a1.5 1.5 0 0 0 1.455-1.136l1-4A1.5 1.5 0 0 0 17.22 6H6.781l-.065-.358A2 2 0 0 0 4.748 4zm12.72 8H7.871l-.91-5H17.22a.5.5 0 0 1 .485.621l-1 4a.5.5 0 0 1-.485.379M11 18.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M9.5 18a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1m7.5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-1.5-.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1"
}), 'EmptyBasket');
//# sourceMappingURL=index.js.map